// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Thankyou_cardWrapper__Zm6U0","innerCardWrapper":"Thankyou_innerCardWrapper__fmG7w","cardBody":"Thankyou_cardBody__RZFLc"};